import axios from "axios";
import { LogOut } from "react-feather";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap";

import Avatar from "@components/avatar";

import { useDispatch, useSelector } from "react-redux";
import { toggleSessionBouncer, resetSession } from "@store/reducers/session";
import { resetCompanies } from "@store/reducers/companies";
import { resetListings } from "@store/reducers/listings";
import { resetDistances } from "@store/reducers/distances";
import { resetTalents } from "@store/reducers/talents";

const UserDropdown = () => {
  const dispatch = useDispatch();

  const session = useSelector(state => state.session);
  const companies = useSelector(state => state.companies);

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>
            {companies.name}
          </span>
          <span className='user-status'>
            {session.account.name} ({session.account.role})
          </span>
        </div>
        <Avatar
          initials
          content={session.account.name || "Unknown"}
          color="light-secondary"
          contentStyles={{ borderRadius: 0, fontSize: "calc(12px)", width: "100%", height: "100%" }}
          style={{ height: "40px", width: "40px" }}
          status='online'
        />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          className="w-100"
          onClick={async () => {
            dispatch(resetSession());
            dispatch(resetCompanies());
            dispatch(resetListings());
            dispatch(resetDistances());
            dispatch(resetTalents());

            await axios({
              method: "POST",
              baseURL: process.env.REACT_APP_MIDDLEWARE_API_URL,
              url: "/company/session/disband",
              withCredentials: true,
            });

            dispatch(toggleSessionBouncer(true));
          }}
        >
          <LogOut size={14} className='me-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
